import * as z from "zod/v4";

export const sendMobileMessageReply = {
  name: "sendMobileMessageReply" as const,
  input: z.object({
    conversationId: z.string(),
    message: z.string().min(1).max(1600),
  }),
  output: z.object({ success: z.boolean() }),
};
